import { useMemo } from 'react';
import useNavMenu from './useNavMenu';
import { navMenuIncludesPath } from '../config/navMenuConfig';

/**
 * Accesos rápidos del header — derivados del menú filtrado (permisos intactos).
 */
export default function useWorkspaceQuickAccess() {
  const menuItems = useNavMenu();

  return useMemo(() => ({
    canPuntoVenta: navMenuIncludesPath(menuItems, '/punto-venta'),
    canReportes: navMenuIncludesPath(menuItems, '/reportes/ventas'),
    canProductos: navMenuIncludesPath(menuItems, '/productos'),
    canProductosNuevo: navMenuIncludesPath(menuItems, '/productos/nuevo'),
    canStock: navMenuIncludesPath(menuItems, '/productos'),
    canConfiguracion: navMenuIncludesPath(menuItems, '/configuracion/empresa')
  }), [menuItems]);
}
